// Utility function to handle affiliate link redirects without showing the URL
export const handleAffiliateClick = (e: React.MouseEvent) => {
  e.preventDefault();
  const affiliateUrl = "https://dashboard.apextraderfunding.com/aff/go/faclez?keyword=review";
  window.open(affiliateUrl, '_blank', 'noopener,noreferrer');
};

export const APEX_AFFILIATE_URL = "https://dashboard.apextraderfunding.com/aff/go/faclez?keyword=review";
